// src/utils/helpers.js
export const shortAddr = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : '');

export const getStudentId = (s) =>
  `${(s.firstName || '').trim().toLowerCase()}-${(s.lastName || '').trim().toLowerCase()}`;

export const getWalletMap = () => JSON.parse(localStorage.getItem('walletMap') || '{}');
export const setWalletMap = (map) => localStorage.setItem('walletMap', JSON.stringify(map));

export const exportAttendanceCSV = (students, attendanceByStudent, weeklyPctFor, monthlyPctFor, calculateMARewards, filter = null) => {
  if (students.length === 0) {
    alert("❌ No students to export");
    return;
  }

  const rows = [["FirstName", "LastName", "Email", "Phone", "Wallet", "Belt", "Week %", "Month %", "Total Classes", "Join Date", "MA+ Tokens"]];

  students.forEach((s) => {
    const id = getStudentId(s);
    const attendanceCount = (attendanceByStudent[id] || []).length;
    const weekly = weeklyPctFor(id);
    const monthly = monthlyPctFor(id);
    const tokens = calculateMARewards(id);

    // Apply filter if specified
    if (filter === 'low' && weekly >= 30) return;
    if (filter === 'inactive' && attendanceCount > 0) return;

    rows.push([
      s.firstName,
      s.lastName,
      s.email || '',
      s.phone || '',
      s.wallet || '',
      s.belt || 'white',
      weekly,
      monthly,
      attendanceCount,
      s.joinDate || '',
      tokens
    ]);
  });

  // Create CSV content
  const csv = rows.map(row => row.join(',')).join('\\n');
  
  // Create download link
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `students-${filter || 'all'}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};